import { type RefObject } from "react";

import { NavLink, type NavLinkProps } from "@mantine/core";
import { createLink } from "@tanstack/react-router";

import styles from "@/components/Navbar/NavbarListItem.module.css";
import { type NavigationItem } from "@/components/Navbar/useNavigationElements";
import { SYSTEM_COLORS } from "@/configs/colorScheme";
import { useIsMobile } from "@/hooks/useIsMobile";

interface CustomNavLinkProps extends NavLinkProps {
  ref?: RefObject<HTMLAnchorElement>;
}

const CustomNavLinkComponent = ({ ref, ...props }: CustomNavLinkProps) => {
  return <NavLink ref={ref} {...props} />;
};

const CustomNavLink = createLink(CustomNavLinkComponent);

interface Props {
  onClose?: () => void;
  navigationItem: NavigationItem;
}
const NavbarListItem = ({ navigationItem, onClose }: Props) => {
  const { isTablet } = useIsMobile();
  const handleOnClose = () => {
    if (onClose) onClose();
  };
  return (
    <CustomNavLink
      {...navigationItem.to}
      label={navigationItem.title}
      leftSection={navigationItem.icon}
      autoContrast
      variant="filled"
      color={SYSTEM_COLORS.secondary}
      className={isTablet ? styles["custom-nav-link-mobile"] : styles["custom-nav-link"]}
      onClick={handleOnClose}
    />
  );
};

export default NavbarListItem;
